module.exports = __webpack_public_path__ + "img/bg_code.8657e6f7.png";